import Dao from '@/dao/dao';
import TrainingCenter from '@/model/training_center';
import Contractor from '@/model/contractor';
import Member from '@/model/member';
import _ from 'underscore';

class MemberDao extends Dao {
  async getMemberByUbcId(ubcId) {
    try {
      const response = await this.api.get(`/member/lookup/${ubcId}`);
      return Member.create(response.data);
    } catch (error) {
      this.handleError(error);
    }
  }

  async getMemberPicture(ubcId) {
    try {
      const response = await this.api.get(`/member/picture/${ubcId}`);
      return response.data.picture;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getTrainingCenter(ubcId) {
    try {
      const response = await this.api.get(`/member/training_center/${ubcId}`);
      const payload = response.data;

      return !payload ? [null, []] : [TrainingCenter.create(payload), _(payload.contractors).map(Contractor.create)];
    } catch (error) {
      this.handleError(error);
    }
  }

  async saveContactInformation(member) {
    try {
      await this.api.post('/member/contact/info', member);
    } catch (error) {
      this.handleError(error);
    }
  }

  async saveEmailAddress(member) {
    try {
      await this.api.post('/member/email', member);
    } catch (error) {
      this.handleError(error);
    }
  }

  async requestEmailVerification(member) {
    try {
      await this.api.post('/member/verify/email', member);
    } catch (error) {
      this.handleError(error);
    }
  }

  async getAnnouncements(ubcId) {
    try {
      const { data: announcements } = await this.api.get(`/member/announcements/${ubcId}`);
      return announcements;
    } catch (error) {
      this.handleError(error);
    }
  }

  async createAccount(payload) {
    try {
      const response = await this.api.post('/portal/account/create', payload);
      return response.data;
    } catch (error) {
      this.handleError(error, 'create-account');
    }
  }

  async verifyActivationToken(token) {
    try {
      const response = await this.api.post('/portal/account/activate/verify', { token });
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async activateAccount(payload) {
    try {
      const response = await this.api.post('/portal/account/activate', payload);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async requestUsername(payload) {
    try {
      const response = await this.api.post('/portal/account/request-username', payload);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async requestPassword(payload) {
    try {
      const response = await this.api.post('/portal/account/request-password', payload);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async verifyResetToken(token) {
    try {
      const response = await this.api.post('/portal/account/reset-password/verify', { token });
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async resetPassword(payload) {
    try {
      const response = await this.api.patch('/portal/account/reset-password', payload);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async alternateAccountLookup(payload) {
    try {
      const response = await this.api.post('/portal/account/account-lookup', payload);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async requestAccountRecovery(payload) {
    try {
      const response = await this.api.post('/portal/account/account-recovery', payload);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async verifyRecoveryToken(token) {
    try {
      const response = await this.api.post('/portal/account/account-recovery/verify', { token });
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async completeAccountRecovery(payload) {
    try {
      const response = await this.api.patch('/portal/account/account-recovery', payload);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async submitContactForm(payload) {
    try {
      const response = await this.api.post('/portal/contact', payload);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }
}

export default new MemberDao();
